import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../common/types';
import { ReactComponent as AppStoreBadge } from '../../assets/images/download/download-appstore-en-light.svg';
import { ReactComponent as GooglePlayBadge } from '../../assets/images/download/download-googleplay-en.svg';
import { MobileOs, storeUrl } from './mobileAppLinks';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole handoff; each part uses its own slice of it */
import styles from './MobileApps.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface StoreBadgesProps {
  /** Show the badge of this system only. Both when not set. */
  os?: MobileOs;
  next?: string;
  isCentered?: boolean;
}

/** The official App Store and Google Play badges (design 1a, 1b, 1d). */
const StoreBadgesComponent: React.FC<StoreBadgesProps> = ({ os, next, isCentered = false }) => {
  const intl = useIntl();

  return (
    <div className={clsx(styles.stores, isCentered && styles.storesCentered)}>
      {os !== 'android' && (
        <a
          className={styles.badge}
          href={storeUrl('ios', next)}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={intl.formatMessage({
            id: 'app.sml.mobileApps.store.ios',
            defaultMessage: 'Download on the App Store',
          })}
        >
          <AppStoreBadge aria-hidden="true" />
        </a>
      )}
      {os !== 'ios' && (
        <a
          className={styles.badge}
          href={storeUrl('android', next)}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={intl.formatMessage({
            id: 'app.sml.mobileApps.store.android',
            defaultMessage: 'Get it on Google Play',
          })}
        >
          <GooglePlayBadge aria-hidden="true" />
        </a>
      )}
    </div>
  );
};

export const StoreBadges = TypedMemo(StoreBadgesComponent);
